import SurveyButton from '@/components/Base/SurveyButton';
import SurveyBackgroundLayout from '@/components/layout/SurveyBackgroundLayout';
import { SurveyContentPanel, SurveyContentPanelInset } from '@/components/layout/SurveyContentPanel';
import { useSurveyLanguage } from '@/hooks/useSurveyLanguage';
import { getTranslations } from '@/locales';
import type { SurveyLanguage } from '@shared/types/surveyLanguage';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();
  const { setSurveyLanguage } = useSurveyLanguage();

  const goAgeSmoker = (lang: SurveyLanguage) => {
    setSurveyLanguage(lang);
    navigate('/age_smoker');
  };

  const tEn = getTranslations('en').home;

  return (
    <SurveyBackgroundLayout>
      <div className="absolute z-10 inset-x-0 top-[12%] flex flex-col items-center text-center">
        <h1 className="text-[36px] font-bold leading-tight tracking-tight text-white drop-shadow-[0_2px_8px_rgba(0,0,0,0.4)] sm:text-[44px]">
          <span className="block">Welcome</span>
          <span className="mt-0.5 block">Selamat Datang</span>
          <span className="mt-0.5 block">欢迎</span>
        </h1>
      </div>

      <div className="absolute z-10 inset-x-0 top-[32%] flex flex-col items-stretch gap-5">
        <SurveyContentPanelInset className="mx-auto w-[86.4%]">
          <SurveyContentPanel className="flex min-h-[12.5rem] flex-col justify-center !py-[1.5rem] sm:min-h-[13.5rem]">
            <div className="mx-auto w-[95%]">
              <p className="m-0">
                {`${tEn.line1} ${tEn.line2} `}
                <span className="whitespace-nowrap">{tEn.line3}</span>
              </p>
              <p className="m-0 mt-[1.65lh]">{`${tEn.line4} ${tEn.line5} ${tEn.line6}`}</p>
            </div>
          </SurveyContentPanel>
        </SurveyContentPanelInset>

        <div className="flex flex-col items-center gap-3 px-6">
          <SurveyButton onClick={() => goAgeSmoker('en')}>ENG</SurveyButton>
          <SurveyButton onClick={() => goAgeSmoker('bm')}>BM</SurveyButton>
          <SurveyButton onClick={() => goAgeSmoker('cn')}>CN</SurveyButton>
        </div>
      </div>
    </SurveyBackgroundLayout>
  );
}
